export const AUTH_TOKEN_STORAGE_KEY = 'auth_token';
